import { useAtomValue } from "jotai";
import type { Answers } from "../types";
import { questionnaireAnswersAtom } from "../state/questionnaireAnswersAtom";

/**
 * Get all answers. Re-renders on ANY answer change - prefer useAnswer(name) when possible.
 *
 * @example const answers = useAnswers();
 * @see useAnswer - single answer (better performance)
 * @see useAnswersForQuestions - subset of answers
 */
export function useAnswers(): Answers {
  return useAtomValue(questionnaireAnswersAtom);
}
